import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Species } from '../../core/models/species.model';
import * as SpeciesActions from './species.actions';

export const speciesesFeatureKey = 'species';

export interface SpeciesState extends EntityState<Species> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Species> = createEntityAdapter<Species>();

export const initialState: SpeciesState = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(SpeciesActions.addSpecies,
    (state, action) => adapter.addOne(action.species, state)
  ),
  on(SpeciesActions.upsertSpecies,
    (state, action) => adapter.upsertOne(action.species, state)
  ),
  on(SpeciesActions.addSpeciess,
    (state, action) => adapter.addMany(action.speciess, state)
  ),
  on(SpeciesActions.upsertSpeciess,
    (state, action) => adapter.upsertMany(action.speciess, state)
  ),
  on(SpeciesActions.updateSpecies,
    (state, action) => adapter.updateOne(action.species, state)
  ),
  on(SpeciesActions.updateSpeciess,
    (state, action) => adapter.updateMany(action.speciess, state)
  ),
  on(SpeciesActions.deleteSpecies,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(SpeciesActions.deleteSpeciess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(SpeciesActions.loadSpeciess,
    (state, action) => adapter.setAll(action.speciess, state)
  ),
  on(SpeciesActions.clearSpeciess,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
